import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { StyledEmployerCardWrap, StyledTitlesWrap } from './EmployerCard.styles';

export const EmployerCardSkeleton = () => {
  return (
    <StyledEmployerCardWrap>
      <Skeleton variant="rectangular" width={296} height={183} />

      <StyledTitlesWrap spacing={1}>
        <Stack spacing={1} width="100%">
          <Skeleton variant="rounded" height={36} />
        </Stack>

        <Skeleton variant="rounded" height={22} />

        <Skeleton variant="rounded" height={22} />

        <Skeleton variant="rounded" height={22} />
      </StyledTitlesWrap>
    </StyledEmployerCardWrap>
  );
};
